<template>
  <div class="row justify-content-center">
    <div class="col-12 card-wrapper">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">
            <span>{{ title }}</span>
          </h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <form class="needs-validation" @submit.prevent="confirm">
            <div class="row justify-content-center">
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="control-label">
                    {{ inputs.comment.label }}
                  </label>

                  <el-input
                    v-model="formData.comment"
                    v-validate="modelValidations.comment"
                    :autosize="{ minRows: 5 }"
                    name="comment"
                    :placeholder="inputs.comment.placeholder"
                    type="textarea"
                  >
                  </el-input>

                  <small>*&nbsp; {{ info }}</small
                  ><br />

                  <small v-show="comment.invalid" class="text-danger">
                    {{ getError('comment') }}
                  </small>
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-md-6 col-sm-12">
                <div class="float-right">
                  <base-button native-type="submit" type="primary">Aceptar</base-button>
                  <base-button type="secondary" @click="$emit('cancel')">Cancelar</base-button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderEventBus from '@/events/buses/orders.event';
import { mapFields } from 'vee-validate';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },

    inputs: {
      type: Object,
      default: () => {
        return {
          comment: {
            label: 'Observación',
            placeholder: 'Ingrese una Observación',
          },
        };
      },
    },

    modelValidations: {
      type: Object,
      default: () => {
        return {
          comment: {
            required: true,
          },
        };
      },
    },

    info: {
      type: String,
      default: 'Ingrese una observación, y pulse aceptar para proceder con el cierre del pedido',
    },
  },

  data() {
    return {
      formData: {
        comment: null,
      },
    };
  },

  computed: {
    ...mapFields(['comment']),
  },

  methods: {
    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    confirm() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          OrderEventBus.close(this.formData.comment);
        }
      });
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>
